module.exports = __webpack_public_path__ + "img/organazation.f2495625.jpeg";